import dayjs from 'dayjs';

export const createData = (time: any, region: any, company: any, status: any) => ({ time, region, company, status });

export const processTimeData = (timeKeys: any, allCountList: any, errCountList: any) => {
    const days = timeKeys.length;
    const allList = [];
    const errList = [];

    for (let i = 0; i < days; i++) {
        const day = timeKeys[i];
        allList.push({ time: day, count: allCountList[day] || 0 });
        errList.push({ time: day, count: errCountList[day] || 0 });
    }

    return { allList, errList };
};

const valueFromCount = (value: any) => {
    if (value == null) {
        return 0;
    }
    if (typeof value === 'number') {
        return value;
    }
    if (typeof value === 'string') {
        const parsed = Number(value);
        return Number.isFinite(parsed) ? parsed : 0;
    }
    if (typeof value === 'object' && Object.prototype.hasOwnProperty.call(value, 'count')) {
        return valueFromCount(value.count);
    }
    return 0;
};

export const sumCounts = (counts: any) =>
    Object.values(counts || {}).reduce((total: number, current: any) => total + Number(valueFromCount(current)), 0);

export const formatFailTime = (failAverageTime: any) => {
    const failAverageTimeRound = failAverageTime ? failAverageTime.toFixed(0) : 0;
    const failMinute = failAverageTimeRound % 60;
    const failHour = ((failAverageTimeRound - failMinute) / 60) % 24;
    const failDay = (failAverageTimeRound - failMinute - failHour * 60) / 1440;

    return { failDay, failHour, failMinute };
};

export const normalizeUploadRecords = (overviewRecords: any, timeOffset: any) =>
    overviewRecords.map((item: any) =>
        createData(dayjs(item.upload_time).add(timeOffset, 'm').format('YYYY-MM-DD HH:mm'), '', '', item.is_normal)
    );
